// import Vue from 'vue';
// import store from '@/store/store';
import VueI18n from './../i18n/i18n';
import localStorageHelper from '../helpers/local-storage-helper';
import AppConstants from '../appConstants';

class ClientSignatures {
    getSignatureTypeOne() {
        return {
            id: 1,
            name: 'Pacote Notícias Real-time',
            options: [
                VueI18n.t('USER_SIGNATURE').Signature_Option_Agency_Safras_RT,
                // VueI18n.t('USER_SIGNATURE').Signature_Option_Other_Agencies,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Tv,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Podcast,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Courses,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Speechs,
            ]
        }
    }

    getSignatureTypeTwo() {
        return {
            id: 2,
            name: 'Pacote Análises',
            options: [
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Today,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Vision,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Estatistic_Export,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Tv,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Podcast,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Courses,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Speechs,
            ]
        }
    }

    getSignatureTypeThree() {
        return {
            id: 3,
            name: 'Pacote Mercados',
            options: [
                VueI18n.t('USER_SIGNATURE').Signature_Option_Agency_Safras_RT,
                // VueI18n.t('USER_SIGNATURE').Signature_Option_Other_Agencies,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Today,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Vision,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Estatistic_Export,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Tv,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Podcast,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Courses,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Speechs,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Weather,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Fisical_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Future_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Indicative,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Exchange_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Lineup_Ships,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Freight_Calculator
            ]
        }
    }

    getSignatureTypeFour() {
        return {
            id: 4,
            name: 'Pacote Live Consultoria',
            options: [
                VueI18n.t('USER_SIGNATURE').Signature_Option_Agency_Safras_RT,
                // VueI18n.t('USER_SIGNATURE').Signature_Option_Other_Agencies,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Today,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Analisy_Agro_Vision,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Estatistic_Export,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Tv,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Safras_Podcast,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Courses,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Speechs,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Weather,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Fisical_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Future_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Indicative,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Exchange_Market,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Lineup_Ships,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Freight_Calculator,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Open_Line,
                VueI18n.t('USER_SIGNATURE').Signature_Option_Monthly_Conference
            ]
        }
    }

}

export default new ClientSignatures();